<template>
  <div class="container">
    <div class="img" style="height: 500px">
      <img
        src="../assets//image/新闻中心.png"
        alt="新闻中心"
        style="height: 500px"
      />
    </div>

    <div class="line"></div>

    <!-- 版心 -->
    <div class="gutter_1">
      <div class="company_news_1">
        <strong>新闻详情</strong>
      </div>

      <div class="new_1">
        <div class="title_content_1">
          <div class="news_tit">{{ dataNews.title }}</div>
          <div class="news_describtion" v-html="dataNews.content"></div>
          <div class="news_time">{{ dataNews.datetime }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsByID } from "@/api";
export default {
  data() {
    return {
      dataNews: {},
    };
  },
  methods: {
    initdetail() {
      let newsId = this.$route.params.id;
      getNewsByID(newsId)
        .then((res) => {
          console.log(res);
          if (res.code === "200") {
            this.dataNews = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.initdetail();
  },
};
</script>

<style>
@media (max-width: 966px) {
  .img img {
    display: none;
  }
  .img {
    height: 0px !important;
  }
  .line {
    display: none;
  }
}
.news_time {
  text-align: left;
  font-size: 16px;
  color: #0858e46c;
  font-weight: 700;
  margin-top: 20px;
}
.news_describtion {
  text-align: left;
  line-height: 40px;
  margin-top: 5px;
  font-size: 18px;
  text-indent: 2em;
}
.news_tit {
  font-size: 20px;
  text-align: left;
  font-weight: 600;
  margin-bottom: 20px;
}
.new_1 {
  display: flex;
  border: 1px solid #2222221d;
  height: auto;
  width: 95%;
  margin: 0 auto;
  border-radius: 10px; /* 添加圆角 */
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.1); /* 添加内阴影以增强立体感 */
  overflow: hidden; /* 防止内容溢出 */
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* 添加过渡效果 */
  margin-bottom: 100px;
  background-color: #f5f5f5;
  margin-bottom: 30px;
  margin-top: 20px;
}

.title_content_1 {
  padding: 15px; /* 添加内边距 */
  border-radius: 0 10px 10px 0; /* 标题和内容区域的右上角和右下角圆角 */
  border-left: 1px solid #ccccccf8;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.gutter_1 {
  width: 88%;
  margin: 0 auto;
  font-size: 20px;
  position: relative; /* 确保伪元素相对于这个容器定位 */
}

.company_news_1 {
  position: relative; /* 确保伪元素可以相对于这个元素定位 */
  display: inline-block; /* 确保元素的宽度与其内容相匹配 */
  color: #333; /* 文本颜色 */
  padding-bottom: 5px; /* 为下面的线留出空间 */
  margin-bottom: 20px;
  font-size: 24px;
  border-bottom: 2px solid #333;
}
.line {
  border-bottom: 2px solid #ccc;
  margin-bottom: 50px;
}
</style>
